import { jsx, jsxs } from "react/jsx-runtime";
import { Fragment } from "react";
import CallCenter from "../MainMenu/components/CallCenter/index.js";
import Logo from "../MainMenu/components/Logo/index.js";
import Navbar from "../MainMenu/ui/Navbar.js";
import NavbarContainer from "../MainMenu/ui/NavbarContainer.js";
import SubmenuBackdrop from "../MainMenu/ui/SubmenuBackdrop.js";
const LightMenu = ()=>/*#__PURE__*/ jsxs(Fragment, {
        children: [
            /*#__PURE__*/ jsx(Navbar, {
                children: /*#__PURE__*/ jsxs(NavbarContainer, {
                    className: "flex items-center justify-center lg:justify-between",
                    children: [
                        /*#__PURE__*/ jsx("div", {
                            className: "flex items-center lg:flex-row-reverse",
                            children: /*#__PURE__*/ jsx(Logo, {
                                targetLink: "_blank"
                            })
                        }),
                        /*#__PURE__*/ jsx("div", {
                            className: "flex items-center",
                            children: /*#__PURE__*/ jsx("div", {
                                className: "hidden mr-20 lg:block",
                                children: /*#__PURE__*/ jsx(CallCenter, {})
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ jsx(SubmenuBackdrop, {})
        ]
    });
const LightMenu_LightMenu = LightMenu;
export default LightMenu_LightMenu;
